import React from "react";
import PortfolioItem from "./PortfolioItem";

const portfolioData = [
  {
    id: 1,
    // image: image1,
    title: "Super App (AI) With 7 Modules",
    link: "#0",
    description:
      "This app includes E-Commerce, Object Detection, Eye controlled app, Doctor consulting, Emotion synthesizer, image recognition and Games for speical need people.",
  },
  {
    id: 2,
    // image: image2,
    title: "Scan ID",
    link: "#0",
    description:
      "An app that scans and stores a person’s ID card along with their face. In future, the app uses facial recognition to automatically pull up the ID details.It’s useful for registrations and attendance management.",
  },
  {
    id: 3,
    // image: image3,
    title: "Flight Booking Portal and App with Admin Panel",
    link: "https://dreamtravels.live/en",
    description:
      "Flight ticket booking system integrating various ticket providers in single platform. Along with admin panel to manage the ticket providers, travel agencies and users.",
  },
  {
    id: 4,
    // image: image4,
    title: "Tool For Employee Management",
    link: "#0",
    description:
      "App for employee management about when they are started working their location verification with geofencing along with Navigation, Location Sharing and Fingerprint Authentication.",
  },
];

const Portfolio = () => {
  return (
    <section className="pb-10">
      <div className="flex flex-wrap md:px-4">
        {portfolioData.map((portfolio, id) => (
          <PortfolioItem portfolio={portfolio} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
